import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { useActiveGenre } from "../../../../utils/Genre/activeGenreState";

export default function ShowAwardsList({ showAwards }) {
  const [activeGenre] = useActiveGenre();

  useEffect(() => {
    console.log("showAwards", showAwards);
  }, [showAwards]);

  const groupIndividualAwards = (individualAwards = []) => {
    return Object.values(
      individualAwards.reduce((groups, award) => {
        const key = award.awardName || "Other";

        if (!groups[key]) {
          groups[key] = {
            awardName: key,
            recipients: [],
            winner: false,
            honoree: false,
          };
        }

        groups[key].recipients.push(award);
        groups[key].winner = groups[key].winner || Boolean(award.winner);
        groups[key].honoree = groups[key].honoree || Boolean(award.honoree);

        return groups;
      }, {}),
    );
  };

  const AwardLabels = ({ winner, honoree }) => {
    return (
      <>
        {winner ? (
          <div className="award-label">
            <div className="ms-auto award-label-line red-line" />
            <div className="px-2 red">WINNER</div>
            <div className="me-auto award-label-line red-line" />
          </div>
        ) : null}

        {honoree ? (
          <div className="award-label" style={{ opacity: 0.5 }}>
            <div className="ms-auto award-label-line" />
            <div className="px-2">HONOREE</div>
            <div className="me-auto award-label-line" />
          </div>
        ) : null}
      </>
    );
  };

  return (
    <>
      {showAwards?.map((c, i) => {
        const groupedIndividualAwards = groupIndividualAwards(c.individual);

        return (
          <div className="competition-container" key={i}>
            <div className="competition-title d-flex justify-content-center">
              <div className="competition-title-inner">{c.name}</div>
            </div>

            {c.program.length ? (
              c.program.map((a, i) => (
                <div key={i} className="award-category">
                  <div className="award-category-name">{a.awardName}</div>
                  <AwardLabels winner={a.winner} honoree={a.honoree} />
                </div>
              ))
            ) : (
              <></>
            )}

            {groupedIndividualAwards.length ? (
              groupedIndividualAwards.map((a, i) => (
                <div key={i} className="award-category">
                  <div className="award-category-name">{a.awardName}</div>

                  {a.recipients.map((recipient, i) => (
                    <div key={i} className="award-recipient-name">
                      {recipient.name}
                    </div>
                  ))}

                  <AwardLabels winner={a.winner} honoree={a.honoree} />
                </div>
              ))
            ) : (
              <></>
            )}

            {c.group.length ? (
              c.group.map((a, i) => (
                <div key={i} className="award-category">
                  <div className="award-category-name">{a.awardName}</div>
                  <div className="award-title-name">{a.name}</div>
                  {a.cast.length ? (
                    a.cast.map((cast, i) => (
                      <span key={i} className="award-recipient-name">
                        {i > 0 ? ", " : ""}
                        {cast.name}
                      </span>
                    ))
                  ) : (
                    <></>
                  )}
                  <AwardLabels winner={a.winner} honoree={a.honoree} />
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        );
      })}
    </>
  );
}
